import React, { useEffect, useRef, useState } from "react";
import "./UpgradeAd.scss";

import { FaChevronRight, FaLightbulb } from "react-icons/fa";
import { FaBookmark } from "react-icons/fa";
import { GiCrown } from "react-icons/gi";
import { MdOutlineWorkspacePremium } from "react-icons/md";

import { Link } from "react-router-dom";
import ROUTES from "../../../constants/routes";
import { useDispatch, useSelector } from "react-redux";
import { updateOpenSubscriptionAd } from "../../../redux/features/subscription-slice";

const planIcons = [<FaLightbulb />, <GiCrown />];

const features = [
  {
    name: "Basic POS Features",
    icon: <FaLightbulb />,
  },
  {
    name: "Advanced reporting",
    icon: <MdOutlineWorkspacePremium />,
  },
  {
    name: "Customer Management",
    icon: <MdOutlineWorkspacePremium />,
  },
  {
    name: "All Features",
    icon: <GiCrown />,
  },
  {
    name: "Priority Support",
    icon: <GiCrown />,
  },
];

const UpgradeAd = () => {
  const { plans: subsPlans, openAd } = useSelector(
    (state) => state.subscriptionReducer.value
  );
  const { subscription, id: organization_id } = useSelector(
    (state) => state.organizationReducer.value
  );
  const { run } = useSelector((state) => state.tourReducer.value);

  const dispatch = useDispatch();

  const leftRef = useRef(null);
  const rightRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const [selectedPackage, setSelectedPackage] = useState(0);

  const [plans, setPlans] = useState([]);

  useEffect(() => {
    if (subsPlans?.length > 0 && organization_id) {
      if (subscription && !(subscription?.plan?.price > 0)) {
        dispatch(updateOpenSubscriptionAd({ openAd: true }));
      } else {
        dispatch(updateOpenSubscriptionAd({ openAd: false }));
      }

      let tempPlans = subsPlans?.map((item) => {
        if (item?.pricing?.monthly?.price > 0) {
          const plan_id =
            item?.pricing?.monthly?.id || item?.pricing?.yearly?.id;
          const price = item?.pricing?.monthly?.id
            ? item?.pricing?.monthly?.price
            : item?.pricing?.yearly?.price;
          const interval = item?.pricing?.monthly?.id ? "mo" : "year";
          return {
            id: plan_id,
            name: item?.name,
            price: `$ ${price}/${interval}`,
            icon: "",
          };
        } else {
          return null;
        }
      });

      tempPlans = tempPlans?.filter((el) => el !== null);

      tempPlans?.forEach((item, i) => {
        if (i % 2 === 0) {
          return (item.icon = planIcons[0]);
        } else {
          return (item.icon = planIcons[1]);
        }
      });

      setPlans(tempPlans);

      if (tempPlans?.length > 0) {
        setSelectedPackage(tempPlans[0]?.id);
      }
    } else {
      dispatch(updateOpenSubscriptionAd({ openAd: false }));
      setPlans([]);
    }
  }, [subsPlans, subscription, organization_id]);

  const handleScroll = (itemRef) => {
    if (itemRef?.current) {
      itemRef?.current?.scrollIntoView({
        block: "nearest",
        behavior: "smooth",
        inline: "center",
      });
    }
  };

  const closeAd = () => {
    setOpen(false);
    dispatch(updateOpenSubscriptionAd({ openAd: false }));
  };

  const [open, setOpen] = useState(false);

  useEffect(() => {
    openAd ? setOpen(true) : setOpen(false);
  }, [openAd]);

  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (open && !run) {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [open, run, isVisible]);

  if (!shouldRender) return null;

  return (
    <div className={`upgrade-ad ${isVisible ? "active" : ""}`}>
      <div className="image">
        <img src={`/images/upgrade/${activeIndex}.png`} alt="" aria-label="Subscription Ad" />

        <p className="skip-button" onClick={closeAd}>
          SKIP
        </p>
      </div>

      <div className="lower-content-wrapper">
        <div className="lower-content">
          <div className="content-slider">
            <div className="package-item slide-item" ref={leftRef}>
              <div className="heading">
                <p>Our Premium Plans</p>
                <span>
                  Daikofin offers the perfect plans for your business. Upgrade
                  now to get the most out of Daiko!
                </span>
              </div>

              <div className="buttons">
                {plans.map((item, i) => {
                  return (
                    <div
                      className={`button ${
                        selectedPackage === item.id ? "active" : ""
                      }`}
                      key={i}
                      onClick={() => {
                        setSelectedPackage(item.id);
                      }}
                    >
                      <FaBookmark className="bookmark-svg" />
                      <div className="left">
                        <span></span>
                        <div className="content">
                          <p className="name">{item.name}</p>
                          <p className="price">{item.price}</p>
                        </div>
                      </div>
                      <p className="icon">{item.icon}</p>
                    </div>
                  );
                })}

                <p className="desc">
                  Subscription does not include any contract. Unsubscribe any
                  time you want.
                </p>
              </div>
            </div>
            <div className="slide-item features-item" ref={rightRef}>
              <div className="heading">
                <p>Boosting Your Brand Visibility with Daikofin</p>
              </div>

              <div className="features">
                {features.map((el, i) => {
                  return (
                    <p key={i}>
                      {el.icon} {el.name}
                    </p>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="navigation-dots">
            <span
              className={activeIndex === 0 ? "active" : ""}
              onClick={() => {
                setActiveIndex(0);
                handleScroll(leftRef);
              }}
            ></span>
            <span
              className={activeIndex === 1 ? "active" : ""}
              onClick={() => {
                setActiveIndex(1);
                handleScroll(rightRef);
              }}
            ></span>
          </div>

          <div className="lower-container">
            <Link
              to={`${ROUTES.upgrade.path}?id=${selectedPackage}`}
              className="link-button"
              onClick={() => {
                dispatch(updateOpenSubscriptionAd({ openAd: false }));
              }}
            >
              Upgrade Now
            </Link>
            <Link
              to={ROUTES.upgradeLearnMore.path}
              className="link-text"
              onClick={() => {
                dispatch(updateOpenSubscriptionAd({ openAd: false }));
              }}
            >
              Learn More
            </Link>

            <p>
              {/* <Link to={"#"}>Restore Purchases</Link> */}
              <a href={"https://daikoapp.com/index.php/73-2/"} target="blank">
                Privacy & terms
              </a>
              {/* <Link to={"#"}>EULA</Link> */}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpgradeAd;
